import { render, staticRenderFns } from "./FotoCheckPdf.vue?vue&type=template&id=2283a1fa"
import script from "./FotoCheckPdf.vue?vue&type=script&lang=js"
export * from "./FotoCheckPdf.vue?vue&type=script&lang=js"
import style0 from "./FotoCheckPdf.vue?vue&type=style&index=0&id=2283a1fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports